import IAccommodationCategory from 'interfaces/IAccommodationCategory';
import RestService from './RestService';

export default class AccommodationCategoryService extends RestService<IAccommodationCategory> {
  constructor() {
    super('accommodation-categories');
  }
}
